const Joi = require("joi");

const inmateMergeSchema = (data) => {
  const schema = Joi.object({
    newInmateId: Joi.number().greater(0).required().messages({
      "number.greater": "Please select Inmate to merge.",
      "any.required": "Please select Inmate to merge.",
    }),
  }).unknown(true);
  return schema.validate(data, {
    abortEarly: false, // This ensures that all validation errors are reported, not just the first one.
  });
};

module.exports = inmateMergeSchema;
